// src/components/AddSamochod.js
import React, { useState, useContext, useEffect, useRef } from "react";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import axios from "axios";
import { AuthContext } from "../../context/AuthContext";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Dropdown } from "primereact/dropdown";
import { PickList } from "primereact/picklist";
import { Checkbox } from "primereact/checkbox";
import EditCarRecipients from "./EditCarRecipients";
import { Toast } from "primereact/toast";
import { useMediaQuery } from "react-responsive";
import { baseURL } from "../../utils/api";

const AddSamochod = ({ onAddSuccess }) => {
  const toast = useRef(null);
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });
  const { user, token } = useContext(AuthContext);
  const [nrRej, setNrRej] = useState("");
  const [firma, setFirma] = useState(null);
  const [firmyOptions, setFirmyOptions] = useState([]);
  const [samochody, setSamochody] = useState([]);
  const [odbiorcyOptions, setOdbiorcyOptions] = useState([]);
  const [source, setSource] = useState([]);
  const [target, setTarget] = useState([]);
  const [expandedRows, setExpandedRows] = useState(null);
  const [recipientsDialogVisible, setRecipientsDialogVisible] = useState(false);
  const [selectedCarForEdit, setSelectedCarForEdit] = useState(null);

  // Dodajemy stan do edycji – który rekord edytujemy
  const [editingSamochod, setEditingSamochod] = useState(null);
  // Kontrola widoczności – domyślnie wyświetlamy tylko dostępne rekordy
  const [showAll, setShowAll] = useState(false);

  const openRecipientsDialog = (car) => {
    setSelectedCarForEdit(car);
    setRecipientsDialogVisible(true);
  };

  const updateCarRecipients = (newRecipients) => {
    // newRecipients to tablica obiektów odbiorców; wyciągamy ich ID
    const targetIds = newRecipients.map((r) => r.id);
    const updatedCar = { ...selectedCarForEdit, odbiorca: targetIds };
    axios
      .put(
        `${baseURL}api/samochody/${selectedCarForEdit.id}/odbiorcy`,
        updatedCar,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then((response) => {
        setSamochody(
          samochody.map((car) =>
            car.id === selectedCarForEdit.id ? response.data : car
          )
        );
      })
      .catch((error) =>
        console.error("Błąd aktualizacji odbiorców samochodu:", error)
      );
  };

  useEffect(() => {
    axios
      .get(`${baseURL}api/kontrahenci`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        setOdbiorcyOptions(response.data);
        setSource(response.data);
      })
      .catch((error) => console.error("Błąd pobierania odbiorców:", error));
  }, [token]);

  // Funkcja do zmiany statusu dostępności – działa tylko w trybie edycji
  const handleToggleAvailability = (samochod) => {
    if (editingSamochod && editingSamochod.id === samochod.id) {
      setEditingSamochod({
        ...editingSamochod,
        dostepny: !editingSamochod.dostepny,
      });
    }
  };

  // Rozpoczęcie edycji rekordu – teraz dodajemy możliwość edycji również statusu dostępności
  const handleEditClick = (samochod) => {
    setEditingSamochod({ ...samochod });
  };

  // Zapis zmian edytowanego rekordu – wysyłamy PUT na endpoint
  const handleSaveClick = () => {
    axios
      .put(`${baseURL}api/samochody/${editingSamochod.id}`, editingSamochod, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        setSamochody(
          samochody.map((s) =>
            s.id === editingSamochod.id ? response.data : s
          )
        );
        setEditingSamochod(null);
        toast.current.show({
          severity: "success",
          summary: "Sukces",
          detail: "Samochód zaktualizowany",
          life: 3000,
        });
      })
      .catch((error) => console.error("Błąd aktualizacji samochodu:", error));
  };

  const handleCancelClick = () => {
    setEditingSamochod(null);
    toast.current.show({
      severity: "info",
      summary: "Anulowano",
      detail: "Anulowano edycję samochodu",
      life: 3000,
    });
  };

  // Dodawanie nowego samochodu – nowy rekord otrzymuje dodatkowo pole dostepny: true
  const handleSubmit = () => {
    const targetIds = target.map((t) => t.id);
    const newSamochod = { nrRej, odbiorca: targetIds, dostepny: true };
    if (samochody.some((samochod) => samochod.nrRej === nrRej)) {
      alert("Samochód o podanym numerze rejestracyjnym już istnieje");
    } else {
      axios
        .post(`${baseURL}api/samochodyAdd`, newSamochod, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((response) => {
          console.log("Dodano samochód:", response.data);
          setNrRej("");
          setTarget([]);
          setSource(odbiorcyOptions);
          setSamochody([...samochody, response.data]);
          onAddSuccess();
        })
        .catch((error) => console.error("Błąd dodawania samochodu:", error));
    }
  };

  useEffect(() => {
    axios
      .get(`${baseURL}api/samochody`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => setSamochody(response.data))
      .catch((error) => console.error("Błąd pobierania samochodów:", error));
  }, [token]);

  const rowExpansionTemplate = (rowData) => {
    console.log(rowData);
    if (!rowData.odbiorca || rowData.odbiorca.length === 0) return null;
    const names = rowData.odbiorca
      .map((id) => {
        const client = odbiorcyOptions.find((c) => c.id === id);
        return client ? client.nazwa : "";
      })
      .filter(Boolean);
    return (
      <div style={{ padding: "1em" }}>
        <h5>Odbiorcy:</h5>
        <ul>
          {names.map((name, i) => (
            <li key={i}>{name}</li>
          ))}
        </ul>
      </div>
    );
  };

  const onChange = (event) => {
    setSource(event.source);
    setTarget(event.target);
  };

  const itemTemplate = (item) => {
    return (
      <div className="flex flex-wrap p-2 align-items-center gap-3">
        <div className="flex-1 flex flex-column gap-2">
          <span className="font-bold">{item.nazwa}</span>
          <div className="flex align-items-center gap-2">
            <i className="pi pi-directions-alt text-sm"></i>
            <span>{item.adres}</span>
          </div>
        </div>
        <span className="font-bold text-900">NIP: {item.nip}</span>
      </div>
    );
  };

  // Kolumna z przyciskami edycji – podczas edycji pojazdu pokazujemy przyciski zapisu/ anulowania
  const actionBodyTemplate = (rowData) => {
    if (editingSamochod && editingSamochod.id === rowData.id) {
      return (
        <React.Fragment>
          <Button
            icon="pi pi-save"
            className="p-button-success p-mr-2"
            onClick={handleSaveClick}
          />
          <Button
            icon="pi pi-times"
            className="p-button-secondary"
            onClick={handleCancelClick}
          />
        </React.Fragment>
      );
    } else {
      return (
        <Button
          // label="Edytuj"
          onClick={() => handleEditClick(rowData)}
          icon="pi pi-pencil"
          className="p-button-text p-button-sm"
        // className="p-button-warning"
        />
      );
    }
  };

  // Kolumna z tekstem – w trybie edycji zamieniamy na InputText
  const textBodyTemplate = (rowData, field) => {
    if (editingSamochod && editingSamochod.id === rowData.id) {
      return (
        <InputText
          value={editingSamochod[field] || ""}
          maxLength={20}
          onChange={(e) =>
            setEditingSamochod({ ...editingSamochod, [field]: e.target.value })
          }
        />
      );
    }
    return rowData[field];
  };

  // Kolumna z dostępnością – checkbox dostępny tylko w trybie edycji (aktywny), poza tym wyświetlany jako disabled
  const availabilityBodyTemplate = (rowData) => {
    if (editingSamochod && editingSamochod.id === rowData.id) {
      return (
        <Checkbox
          checked={editingSamochod.dostepny}
          onChange={() => handleToggleAvailability(rowData)}
        />
      );
    } else {
      return <Checkbox checked={rowData.dostepny} disabled />;
    }
  };

  return (
    <div>
      <div className="add-form">
        <h3>Dodaj nowy samochód</h3>
        <div className="add-input">
          <label>Rejestracja:</label>
          <InputText
            className="add-inputText"
            value={nrRej}
            onChange={(e) => setNrRej(e.target.value)}
          />
        </div>
        <label>Odbiorcy:</label>
        <div
          className="card"
          style={{ width: "100%", marginTop: "1rem", marginBottom: "1rem" }}
        >
          <PickList
            dataKey="id"
            source={source}
            target={target}
            itemTemplate={itemTemplate}
            showSourceControls={false}
            showTargetControls={false}
            sourceHeader="Dostępni odbiorcy"
            targetHeader="Wybrani odbiorcy"
            onChange={onChange}
            filter
            filterBy="nazwa"
            breakpoint="800px"
            sourceStyle={{ height: "24rem" }}
            targetStyle={{ height: "24rem" }}
            sourceFilterPlaceholder="Szukaj po nazwie"
            targetFilterPlaceholder="Szukaj po nazwie"
          />
        </div>
        <Button
          label="Dodaj samochód"
          onClick={handleSubmit}
          disabled={!nrRej || !target.length}
        />
      </div>
      <Button
        label={showAll ? "Pokaż tylko dostępne" : "Pokaż wszystkie"}
        onClick={() => setShowAll(!showAll)}
        style={{ margin: "1rem 0" }}
      />
      {isMobile && (
        <div style={{ textAlign: "center", marginTop: "1rem" }}>
          <i>
            W celu uzyskania lepszej widoczności danych, skorzystaj z orientacji
            poziomej
          </i>
        </div>
      )}
      <DataTable
        value={showAll ? samochody : samochody.filter((s) => s.dostepny)}
        paginator
        rows={10}
        rowsPerPageOptions={[5, 10, 15]}
        selectionMode="single"
        expandedRows={expandedRows}
        onRowToggle={(e) => setExpandedRows(e.data)}
        rowExpansionTemplate={rowExpansionTemplate}
        style={{ marginTop: "30px" }}
      >
        <Column expander style={{ width: "3em" }} />
        <Column
          field="nrRej"
          header="Numer rejestracyjny"
          sortable
          body={(rowData) => textBodyTemplate(rowData, "nrRej")}
        />
        <Column
          header="Dostępny"
          field="dostepny"
          sortable
          body={availabilityBodyTemplate}
          headerStyle={{ textAlign: "center", width: "7rem" }}
          bodyStyle={{ textAlign: "center" }}
        />
        <Column
          header="Edytuj odbiorców"
          headerStyle={{ textAlign: "center", width: "12rem" }}
          body={(rowData) => (
            <Button
              label="Edytuj odbiorców"
              onClick={() => openRecipientsDialog(rowData)}
              className="p-button-info p-button-sm"
            />
          )}
        />
        <Column header="Edytuj" body={actionBodyTemplate} />
      </DataTable>

      <EditCarRecipients
        visible={recipientsDialogVisible}
        onHide={() => setRecipientsDialogVisible(false)}
        currentRecipients={
          selectedCarForEdit
            ? odbiorcyOptions.filter((c) =>
              selectedCarForEdit.odbiorca.includes(c.id)
            )
            : []
        }
        allRecipients={odbiorcyOptions}
        onSave={updateCarRecipients}
      />
    </div>
  );
};

export default AddSamochod;
